// src/services/patientDiscovery.js
//
// Read-only discovery calls for /patient/book-appointment. Every call accepts
// an AbortSignal so a superseded search can be cancelled. The patient is
// identified by the session token only; no patient id is ever sent.

import { api } from "../lib/patientApi";

const BASE = "/api/v1/patients/me/appointments/search";

export function cleanParams(params = {}) {
  return Object.fromEntries(
    Object.entries(params).filter(([, value]) => {
      if (value === undefined || value === null || value === false) return false;
      if (typeof value === "string" && value.trim() === "") return false;
      return true;
    })
  );
}

export const patientDiscoveryApi = {
  async services(params = {}, { signal } = {}) {
    const res = await api.get(`${BASE}/services`, { params: cleanParams(params), signal });
    return res.data;
  },

  async filterOptions(params = {}, { signal } = {}) {
    const res = await api.get(`${BASE}/filter-options`, { params: cleanParams(params), signal });
    return res.data;
  },

  async slots(params = {}, { signal } = {}) {
    const res = await api.get(`${BASE}/slots`, { params: cleanParams(params), signal });
    return res.data;
  },
};

export default patientDiscoveryApi;
